import {
  ParticipantView,
  StreamVideoParticipant,
  hasScreenShare,
  hasAudio,
} from '@stream-io/video-react-sdk';
import { CustomParticipantViewUIOthers } from './custom-participant-view-uI';
import { MicOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type Props = {
  participants: StreamVideoParticipant[];
};

export const ParticipantList = ({ participants }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="w-full h-full min-h-[75vh] mt-4 overflow-y-clip">
      {participants.map((participant) => {
        return (
          <div
            key={participant.userId}
            className="w-full min-h-[75vh] flex flex-col items-center relative"
          >
            <ParticipantView
              className="participant-view-others"
              participant={participant}
              ParticipantViewUI={() => <CustomParticipantViewUIOthers />}
              trackType={hasScreenShare(participant) ? 'screenShareTrack' : 'videoTrack'}
            />
            {hasAudio(participant) ? (
              <></>
            ) : (
              <div className="absolute inset-x-0 bottom-0 mb-12 flex items-center justify-center">
                <div className="w-fit bg-red-500 rounded-full p-2 text-white flex items-center space-x-2">
                  <div className="w-4 h-4">
                    <MicOff className="w-4 h-4" />
                  </div>
                  <p>{t('video_call.psychologistMuted')}</p>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
